'use strict';
var trackingUtils = require('../modules/utils/tracking.utils');

Odigeo.defineWidget('calendar_grid', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        daysOfFlexibility: 2, // max for OW: 5, max for RT: 2
        pricePlaceholder: '--',
        daysOfFreshness: 5,
        searchStrategy: Odigeo.AB.isFlexibleDatesSearchPrice ? 'SEARCH_PRICE' : 'SEARCH_INDEXER',
        interfaceClient: 'ONE_FRONT_DESKTOP',
        defaults: {
            numOfResults: 0,
            usesCount: 0,
            cheapest: [],
        },

        init: function() {
            this.getFlexibleDates();
        },

        url: function() {
            return Odigeo.Settings.getProperty('serviceUrlFormatter')('flexibledates');
        },

        getFlexibleDates: function() {
            var searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            var request = this.getFlexibleDatesRequest();
            var lastFlexibleSearchData = this.get('lastFlexibleSearchData');
            var newSearchData = JSON.stringify(request);

            if (!searchParams || searchParams.type !== 'oneWayTrip') {
                this.set('lastFlexibleSearchData', '');
                this.set('flexibleDatesInfo', null);
            } else if (request && lastFlexibleSearchData !== newSearchData) {
                this.set('lastFlexibleSearchData', newSearchData);
                return this.fetch({
                    data: newSearchData,
                    dataType: 'json',
                    contentType: 'application/json',
                    type: 'POST',
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                });
            }
        },

        getFlexibleDatesRequest: function() {
            var searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            if (!searchParams) {
                return false;
            }
            return {
                originGeoNode: searchParams.searchSegments[0].departure.geoNodeId,
                destinationGeoNode: searchParams.searchSegments[0].destination.geoNodeId,
                departureDate: searchParams.searchSegments[0].dateStr,
                site: Odigeo.SessionScope.website,
                resident: searchParams.resident,
                adults: searchParams.numAdults,
                children: searchParams.numChildren,
                infants: searchParams.numInfants,
                interfaceClient: this.interfaceClient,
                priceCalculationCriteria: Odigeo.SessionScope.sortCriteria,
                numberOfDaysFlexibility: this.daysOfFlexibility,
                priceFreshnessDays: this.daysOfFreshness,
                searchStrategy: this.searchStrategy,
            };
        },

        requestSuccessHandler: function(model, response) {
            if (response.errors === null) {
                this.parseResponse(response);
            } else {
                this.requestErrorHandler();
            }
        },

        requestErrorHandler: function() {
            this.set('flexibleDatesInfo', null);
        },

        updateSearchPrice: function() {
            const searchPrice = Odigeo.Session.get('cheapestItineraryPrice');
            const roundedPrice = Math.ceil(searchPrice);
            const priceOptions = Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0});
            const searchFormattedPrice = Odigeo.Utils.formatCurrency(roundedPrice, priceOptions);
            const flexibleDatesInfo = Odigeo._.map(this.get('flexibleDatesInfo'), function(item) {
                return Odigeo._.extend(item, item.selected ? {price: searchPrice, parsedPrice: searchFormattedPrice} : {});
            });

            this.set('flexibleDatesInfo', flexibleDatesInfo);
        },

        parseResponse: function(response) {
            const suffix = 'T00:00:00';
            const stringFormat = Odigeo.Utils.formatDate.masks.isoDateTime;
            const searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            const searchDate = Odigeo.Utils.parseDate(searchParams.searchSegments[0].dateStr + suffix, stringFormat);
            const startDate = Odigeo.Utils.addDays(searchDate.getTime(), this.daysOfFlexibility * -1 );
            const priceOptions = Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 0});
            const searchPrice = Odigeo.Session.get('cheapestItineraryPrice');
            const roundedPrice = Math.ceil(searchPrice);
            const searchFormattedPrice = Odigeo.Utils.formatCurrency(roundedPrice, priceOptions);

            const emptyResults = Odigeo._.map(Odigeo._.range(this.daysOfFlexibility * 2 + 1), Odigeo._.bind(function(index) {
                const currentDate = new Date(Odigeo.Utils.addDays(startDate, index));
                return {
                    parsedPrice: this.pricePlaceholder,
                    selected: Odigeo.Utils.equalDates(currentDate, searchDate),
                    date: Odigeo.Utils.formatDate(currentDate, Odigeo.Utils.formatDate.masks.isoDate),
                    parsedDate: Odigeo.Utils.formatDate(
                        currentDate,
                        this.widget.options.extendedDayDateFormat),
                    valid: currentDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0),
                };
            }, this));

            const parsedResponse = Odigeo._.map(response.matrixEntries, function(entry) {
                const price = Odigeo._.find(entry.apparentPrices, function(price) {
                    return price.apparentPriceCriteria === Odigeo.SessionScope.sortCriteria;
                }).apparentPrice.amount;
                const roundedPrice = Math.ceil(price);

                return {
                    date: entry.departureDate,
                    price: price,
                    parsedPrice: Odigeo.Utils.formatCurrency(roundedPrice, priceOptions),
                };
            });

            this.set('numOfResults', parsedResponse.length);

            const results = Odigeo._.map(emptyResults, function(item, index) {
                const match = Odigeo._.find(parsedResponse, {date: item.date});
                const isSelected = item.selected && searchPrice;
                const selectedPrice = isSelected ? {price: searchPrice, parsedPrice: searchFormattedPrice} : {};
                return Odigeo._.extend({}, item, match, {key: index}, selectedPrice);
            });
            this.set('flexibleDatesInfo', results);
        },
    }),

    viewClass: Odigeo.View.extend({
        minResultsToDisplay: 2,

        selectors: {
            template: '.calendargrid_template',
            wrapper: '.calendargrid_wrapper',
        },

        events: {
            'tap .calendargrid_cell': 'onClickHandler',
        },

        init: function() {
            this.listenTo(this.model, 'change:flexibleDatesInfo', Odigeo._.partial(this.refreshView, true));
        },

        refreshView: function(tracking) {
            var flexibleDatesInfo = this.model.get('flexibleDatesInfo');
            var calendarGridTemplate;
            var flexibleDatesAvailable = Odigeo._.size(flexibleDatesInfo) > 0;
            var shouldShowCalendarGrid = this.model.get('numOfResults') >= this.minResultsToDisplay;

            if (tracking) {
                trackingUtils.trackEvent('on_load', 'OW_flex_days_' + this.model.get('numOfResults') + '_' + this.model.get('usesCount'));
            }

            if (flexibleDatesAvailable && shouldShowCalendarGrid) {
                calendarGridTemplate = Odigeo._.template(this.$cachedSelectors.template.html(), Odigeo.Utils.getTmplSettings({variable: null}));
                this.$cachedSelectors.wrapper.html(calendarGridTemplate({
                    'flexibleDatesInfo': flexibleDatesInfo,
                    'showSpinners': true,
                }));

                this.setCheapestPrice();
                this.setSelectedSearch();
            } else {
                this.$cachedSelectors.wrapper.html('');
            }

            Odigeo.trigger(this.widget.id + ':refreshed', flexibleDatesAvailable);
            this.enableSpinners();
        },

        setCheapestPrice: function() {
            var flexibleDatesInfo = this.model.get('flexibleDatesInfo');
            var cheapest = Odigeo._.min(Odigeo._.filter(flexibleDatesInfo, {valid: true}), function(obj) {
                return parseInt(obj.price, 10);
            });
            var cheapestList = Odigeo._.filter(flexibleDatesInfo, {price: cheapest.price});

            this.model.set('cheapest', Odigeo._.map(cheapestList, 'key'));

            Odigeo._.each(cheapestList, function(obj) {
                this.$cachedSelectors.wrapper.find('.calendargrid_cell[data-key="' + obj.key + '"]')
                    .addClass('cheapest_price');
            }, this);
        },

        setSelectedSearch: function() {
            var selected = this.getSelectedFlexibleDatesInfoElement('selected');

            if (Odigeo._.isUndefined(selected)) {
                selected = this.getSelectedFlexibleDatesInfoElement();
            }

            this.$cachedSelectors.wrapper.find('.calendargrid_headercell, .calendargrid_cell').removeClass('selected_search_day');
            this.$cachedSelectors.wrapper
                .find('.calendargrid_headercell[data-key="' + selected + '"], .calendargrid_cell[data-key="' + selected + '"]')
                .addClass('selected_search_day');
            this.clearSpinner(selected);
        },

        getSelectedFlexibleDatesInfoElement: function(type) {
            var flexibleDatesInfo = this.model.get('flexibleDatesInfo');

            return Odigeo._.first(Odigeo._.filter(flexibleDatesInfo, function(obj) {
                return type === 'selected' ? obj.selected : obj.main;
            })).key;
        },

        onClickHandler: function(event) {
            var addSign = function(number) {
                return number > 0 ? '+' + number : number;
            };
            var flexibleDatesInfo = this.model.get('flexibleDatesInfo');
            var key = $(event.target).data('key');
            var selected = Odigeo._.find(flexibleDatesInfo, 'selected');
            var data = Odigeo._.find(flexibleDatesInfo, {key: key});
            var usages = this.model.get('usesCount');
            var cheapest = ~Odigeo._.indexOf(this.model.get('cheapest'), key) ? 'YES' : 'NO';
            var priceDifference = addSign(Math.round(data.price - selected.price));
            var position = addSign(key - 2);

            if (data.valid && !data.selected) {
                var newSearchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
                this.model.set('usesCount', usages + 1);
                var label = [position, priceDifference, cheapest, usages];
                trackingUtils.trackEvent('flexible_dates', 'OW_flex_days_' + label.join('_'));
                newSearchParams.searchSegments[0].dateStr = data.date;
                newSearchParams.isCalendarSearch = true;
                Odigeo.trigger(this.widget.id + ':search', newSearchParams);
            }
        },

        enableSpinners: function() {
            Odigeo._.forEach(Odigeo._.shuffle(Odigeo._.range(5)), function(index) {
                setTimeout(Odigeo._.bind(function() {
                    this.clearSpinner(index);
                }, this), Odigeo._.random(1000, 4000));
            }, this);
        },

        clearSpinner: function(key) {
            this.$cachedSelectors.wrapper.find('.calendargrid_cell_spinner[data-key="' + key + '"]').remove();
            this.$cachedSelectors.wrapper.find('.calendargrid_cell[data-key="' + key + '"]').removeClass('odf-hidden');
        },
    }),

    refreshData: function() {
        this.model.getFlexibleDates();
    },

    refreshSearchPrice: function() {
        this.model.updateSearchPrice();
        this.view.refreshView();
    },

    enableSpinners: function() {
        this.view.enableSpinners();
    },
}));
